import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=aba72506&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba72506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aba72506')) {
      api.createRecord('aba72506', component.options)
    } else {
      api.reload('aba72506', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=aba72506&scoped=true&", function () {
      api.rerender('aba72506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24UxzxdjyieTj/JS/comp/SearchFilterTokens.vue"
export default component.exports